import React, {Component} from 'react'
import {Button, Tooltip} from 'antd'
import PropTypes from 'prop-types'

class FilterButton extends Component {
  render() {
    return (
      <Tooltip title="Filter">
        <Button
          style={{float: this.props.float}}
          type={this.props.enabled ? 'primary' : 'dashed'}
          icon={'filter'}
          onClick={this.props.onClick}
          {...this.props}>
          {this.props.children}
        </Button>
      </Tooltip>
    )
  }
}

FilterButton.propTypes = {onClick: PropTypes.func}
FilterButton.defaultProps = {size: 'small', float: 'right', enabled: false}

export default FilterButton
